
<div class="admin-dashboard">
    <h1>Tableau de bord Admin</h1>

    <div class="dashboard-content">

        <div class="dashboard-section">
            <h4>Utilisateurs</h4>
            <h6>
                <a routerLink ="/admin/users">Utilisateurs </a> <br /> 
                <a routerLink ="/admin/contracts">Contrats </a>
            </h6>
        </div>

        <div class="dashboard-section">
            <h4>Vehicules</h4>
            <h6>
                <a routerLink ="/admin/carrefs">Modeles Ref </a> <br /> 
                <a routerLink ="/admin/cars">Véhicules </a>
            </h6>
        </div>

        <div class="dashboard-section">
            <h4>Services</h4>
            <h6>
                <a routerLink ="/admin/buy">Ventes </a> <br /> 
                <a routerLink ="/admin/rent">Locations </a> <br /> 
                <a routerLink ="/admin/keep">Entretiens </a>
            </h6>
        </div>

        <div class="dashboard-section">
            <h4>Opérations</h4>
            <h6>
                <a routerLink ="/admin/appointments">Rendez vous </a> <br /> 
                <a routerLink ="/admin/communications">Communications </a>
                <!-- 
                <a routerLink ="/admin/transactions">Transactions </a> <br /> 
                <a routerLink ="/admin/validations">Validations </a> 
                -->
            </h6>
        </div>
    </div>
</div>